import React from "react";
import { useIsMobile } from "../../../../Hooks";
import useStyles from "./FmMulticoteAgriCard.style";
import { Input } from "@mui/material";

interface FmMulticoteAgriCardProps {
    name: string | null;
    percentage: number;
    onRemove: () => void;
    onUpdate?: () => void;
    isDisplayed?: boolean;
}

const FmMulticoteAgriCard = ({ name, percentage, onRemove, onUpdate, isDisplayed = true }: FmMulticoteAgriCardProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();
    return (
        <div className={isMobile ? classes.mobile_container : classes.container}>
            <div className={classes.box}>
                <div style={{ display: "flex", flex: 3 }}>
                    <span className={isMobile ? classes.mobile_name : classes.name}>{name}</span>
                </div>
                <div className={classes.boxCard}>
                    {isDisplayed && (
                        <div className={classes.inputCardContainer}>
                            <Input
                                type='number'
                                placeholder='0'
                                onChange={onUpdate}
                                defaultValue={percentage ? percentage.toString() : ""}
                                inputProps={{ maxLength: "3", max: "100", min: "0" }}
                                style={{
                                    width: 40,
                                    fontSize: 26,
                                    fontWeight: 300,
                                    textAlign: "center",
                                }}
                            />
                            <span className={classes.sign}>%</span>
                        </div>
                    )}
                    <span className={isDisplayed ? classes.icon_container : classes.removeImage}>
                        <img src={"/multi-match/assets/remove.png"} onClick={onRemove} />
                    </span>
                </div>
            </div>
        </div>
    );
};

export default FmMulticoteAgriCard;
